import 'iconify-icon'; // For mdi icons
// Import the core and the DOM watching functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faPlay,
  faPause,
  faTextSize,
  faBackwardStep,
  faChevronLeft,
  faCheck,
  faVolume,
  faVolumeSlash,
  faExpand,
  faGlobe,
  faShareFromSquare,
  faArrowRotateLeft10,
  faArrowRotateRight10,
  faBackward,
  faForward,
} from '@fortawesome/pro-solid-svg-icons';

const icons = [
  faPlay,
  faPause,
  faTextSize,
  faBackwardStep,
  faChevronLeft,
  faCheck,
  faVolume,
  faVolumeSlash,
  faExpand,
  faGlobe,
  faShareFromSquare,
  faArrowRotateLeft10,
  faArrowRotateRight10,
  faBackward,
  faForward,
];

// Add the icons you plan to use to the library
library.add(icons);

// Initiate the auto replacement: this will scan the DOM
// for any <i> tags that use Font Awesome classes and replace them with SVGs.
dom.watch();
